// global data update broadcast should be handeled by one tab to avoid
// duplicate requests by all tabs that overload already busy server
// while heavy tasks are going on (permanenent deletion, batchload etc)
// creating unique tabId in localStorage which is then picked up
// by a winner tab which fetches global data from server and broadcasts it
// other tabs listen to the broadcast and update their redux and memory storages
// listening and fetching is inside useFetchGlobalData hook

const LOCK_KEY = 'rm_global_data_lock';
const LOCK_TTL_MS = 5000; // expiry
const CHANNEL_NAME = 'rm_global_data_channel';

interface LockEntry {
  tabId: string;
  expiresAt: number;
}

const TAB_ID = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export function tryAcquireTabLock(): boolean {
  const raw = localStorage.getItem(LOCK_KEY);
  if (raw) {
    const entry: LockEntry = JSON.parse(raw);
    if (entry.expiresAt > Date.now() && entry.tabId !== TAB_ID) {
      return false;
    }
  }
  const entry: LockEntry = { tabId: TAB_ID, expiresAt: Date.now() + LOCK_TTL_MS };
  localStorage.setItem(LOCK_KEY, JSON.stringify(entry));
  const written: LockEntry = JSON.parse(localStorage.getItem(LOCK_KEY)!);
  return written.tabId === TAB_ID;
}

export function releaseTabLock(): void {
  const raw = localStorage.getItem(LOCK_KEY);
  if (!raw) {
    return;
  }
  const entry: LockEntry = JSON.parse(raw);
  if (entry.tabId === TAB_ID) {
    localStorage.removeItem(LOCK_KEY);
  }
}

export function getGlobalDataChannel(): BroadcastChannel {
  return new BroadcastChannel(CHANNEL_NAME);
}
